












































































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component } from 'vue-property-decorator';
import { MswAppTitle } from '@/shared/msw-app-title';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import { ColumnsAdjustRequestData, ColumnSortRequestData, SortedColumnInfo, SwTable, TableColumnConfig, TableEntry } from '@libs-uuif/shared/sw-table';
import { SwContentToolbar } from '@sonicwall/unified-ui-framework/src/shared/sw-content-toolbar';
import { DropMenuItem, SwDropMenu } from '@libs-uuif/shared/sw-drop-menu';
import { FilterSearchConfig, GlobalSearchConfig, PrefFileDownlodReport } from './types';
import { SwExpandableTextfield, SwTextfield } from '@libs-uuif/shared/sw-textfield';
import { MswApiService } from '@/shared/msw-api-service';
import { uniqueId, cloneDeep } from 'lodash';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwChip } from '@libs-uuif/shared/sw-chip';
import ExportcsvService from '@/shared/msw-exportcsv.service';
import { CreateElement, VNode } from 'vue';

const cssPrefix: string = 'prefFileDownloadReportPrefix';

@Component({
  components: {
    MswAppTitle,
    SwContentToolbar,
    SwIconButton,
    SwDropMenu,
    SwExpandableTextfield,
    SwTable,
    SwTextfield,
    SwIcon,
    SwChip,
  },
})
export default class MswPrefFileDownloadReport extends SwExtendedVue {
  cssPrefix = cssPrefix;
  menuOpened: boolean = false;
  sortedColumns: SortedColumnInfo[] = [];
  isLoadingData: boolean = true;
  adjustedColumns: ColumnsAdjustRequestData = {};
  searchInputChips: string[] = [];
  tableData: PrefFileDownlodReport[] = [];
  tempTableData:  PrefFileDownlodReport[] = [];
  globalSearchConfig: GlobalSearchConfig = {
    isExpandSearchFilter: false,
    globalSearchKey: '',
  };

  filterSearchConfig: FilterSearchConfig = {
    isEnableFilterSearch: false,
    filterSearchKey:'',
    filterSearchOption:'',
    filterSearchLabel:'',
  };

  created() : void {
    this.fetchPrefFileData();
  }

  get tableHeight(): string {
    if (this.isFilterApplied) {
      return 'calc(100vh - 385px)';
    }
    return 'calc(100vh - 340px)';
  }

  get isFilterApplied(): boolean {
    return this.filterSearchConfig.isEnableFilterSearch || this.searchInputChips.length > 0;
  }

  get filterItems(): DropMenuItem[] {
    return [
      {
        id: 'SerialNumber',
        content: 'SerialNumber',
      },
      {
        id: 'FriendlyName',
        content:'FriendlyName',
      },
      {
        id: 'Model',
        content: 'Model',
      },
      {
        id: 'productGroupName',
        content: 'Tenant Name',
      },
      {
        id: 'RegDate',
        content: 'Registered',
      },
      {
        id: 'FirmwareVersion',
        content: 'Firmware Version',
      },
      {
        id: 'PreferenceFileName',
        content: 'Preference File Name',
      },
      // {
      //   id: 'LastDownloadTime',
      //   content: 'Last Download Time',
      // },
    ];
  }

  get returnData(): TableEntry[] {
    const rowData = cloneDeep(this.tableData) || [];
    const tableEntry: TableEntry[] = [];
    rowData.forEach((data: PrefFileDownlodReport) => {
      const entry: TableEntry = {
        ...data,
        _key: uniqueId(),
      };
      tableEntry.push(entry);
    });
    return tableEntry;
  }

  get getColumnsConfig(): TableColumnConfig[] {
    return [
      {
        key: 'index',
        type: 'index',
      },
      {
        key: 'SerialNumber',
        dataKey: 'SerialNumber',
        title: 'SerialNumber',
        sorter: true,
        width: 150,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div>
            <a style="color: #47afe8;" onClick={() => this.serialNumberClick(data.entry.SerialNumber)}>{ data.entry.SerialNumber }</a>
          </div>
        ) as VNode;
        },
      },
      {
        key: 'FriendlyName',
        dataKey: 'FriendlyName',
        title: 'Friendly Name',
        sorter: true,
        width: 200,
      },
      {
        key: 'Model',
        dataKey: 'Model',
        title: 'Model',
        sorter: true,
      },
      {
        key: 'productGroupName',
        dataKey: 'productGroupName',
        title: 'Tenant Name',
        sorter: true,
      },
      {
        key: 'RegDate',
        dataKey: 'RegDate',
        title: 'registered',
        sorter: true,
      },
      {
        key: 'FirmwareVersion',
        dataKey: 'FirmwareVersion',
        title: 'Firmware Version',
      },
      {
        key: 'PreferenceFileName',
        dataKey: 'PreferenceFileName',
        title: 'Preference File Name',
      },
      // {
      //   key: 'LastDownloadTime',
      //   dataKey: 'LastDownloadTime',
      //   title: 'Last Download Time',
      // },
    ] as TableColumnConfig[];
  }

  public onRemoveAllFilters() : void {
    this.globalSearchConfig = {
      isExpandSearchFilter: false,
      globalSearchKey: '',
    };
    this.filterSearchConfig = {
      isEnableFilterSearch: false,
      filterSearchKey:'',
      filterSearchOption:'',
      filterSearchLabel:'',
    };
    this.searchInputChips = [];
    this.applyAllFilters();
  }

  public refreshPrefFileDownloadReport(): void {
    this.fetchPrefFileData();
  }

  public onSelectMultiItem(type: string): void {
    this.menuOpened = !this.menuOpened;
    // this.globalSearchValue = '';
    const isExistingChip = this.searchInputChips?.find((el: any) => el.column === type);
    if (!isExistingChip) {
      this.filterSearchConfig.isEnableFilterSearch = true;
      this.filterSearchConfig.filterSearchOption = type;
      const title: string = (this.filterItems.filter(ele => ele.id.toString() === type)[0].content) as string || '';
      this.filterSearchConfig.filterSearchLabel = title;
    }
    this.$nextTick(() => {
      const filterInput = document.getElementById('filtersearch') as HTMLElement;
      if (filterInput) {
        filterInput.children[0]
            .getElementsByTagName('input')[0]
            .focus();
      }
    });
  }

  public handleSearchFilter(): void {
    if (this.globalSearchConfig.globalSearchKey !== '') {
      this.searchInputChips.push(this.globalSearchConfig.globalSearchKey.trim());
      this.applyAllFilters();
      this.globalSearchConfig.globalSearchKey = '';
    }
    this.globalSearchConfig.isExpandSearchFilter = !this.globalSearchConfig.isExpandSearchFilter;
  }

  public onRequestAdjustColumns(data: ColumnsAdjustRequestData): void {
    this.adjustedColumns = data;
  }

  public addFilterKey(event: any): void {
    if (event.code === 'Enter' && this.filterSearchConfig.filterSearchKey !== '') {
      this.searchInputChips.push(this.filterSearchConfig.filterSearchKey.trim());
      this.applyAllFilters(this.filterSearchConfig.filterSearchOption);
      this.filterSearchConfig.filterSearchKey = '';
      this.filterSearchConfig.filterSearchLabel = '';
      this.filterSearchConfig.isEnableFilterSearch = false;
    }
  }

  public removeInputChip(index: any): void {
    this.searchInputChips.splice(index, 1);
    this.applyAllFilters();
  }

  public onRequestSorting(data: ColumnSortRequestData): void {
    data.cancel = false;
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }

  public fetchPrefFileData() : void {
    this.tableData  = [];
    this.isLoadingData = true;
    this.$store.commit('startLoading');
    const userId = this.$store.getters.getUserId;
    MswApiService.preffileReport.getPreffileReport({ username: userId })
      .then((res: any) => {
        this.tableData = (res.content.Records as PrefFileDownlodReport[]) || [];
        this.tempTableData = cloneDeep(this.tableData);
      })
      .catch((errRes: Error) => {
        console.error(errRes);
      })
      .finally(() => {
        this.$store.commit('stopLoading');
        this.isLoadingData = false;
      });
  }

  public applyAllFilters(option : any = 'all') {
    const data: any[] = [...this.tempTableData];
    const filteredData : any[] = [];
    this.$store.commit('startLoading');
    if (this.searchInputChips.length === 0) {
      this.tableData = [...data];
      this.$store.commit('stopLoading');
      return;
    }
    if (option === 'all') {
      this.searchInputChips.forEach((searchKey: string) => {
        filteredData.push(...data.filter((element: any) => {
          console.warn(element);
          // console.warn(element.name.indexOf(searchKey) > -1);
          // tslint:disable:newline-per-chained-call
          return (element.SerialNumber.toLowerCase().indexOf(searchKey.toLowerCase()) > -1 ||
                 element.FriendlyName.toLowerCase().indexOf(searchKey.toLowerCase()) > -1 ||
                 element.Model.toLowerCase().indexOf(searchKey.toLowerCase()) > -1 ||
                 element.productGroupName.toLowerCase().indexOf(searchKey.toLowerCase()) > -1 ||
                 element.FirmwareVersion.toLowerCase().indexOf(searchKey.toLowerCase()) > -1 ||
                 element.PreferenceFileName.toLowerCase().indexOf(searchKey.toLowerCase()) > -1 ||
                //  element.LastDownloadTime.toLowerCase().indexOf(searchKey.toLowerCase()) > -1 ||
                 element.RegDate.toLowerCase().indexOf(searchKey.toLowerCase()) > -1);
        }));
      });
      filteredData.forEach((ele:any, index: any) => {
        ele['_key'] = index + 1;
      });
    } else {
      this.searchInputChips.forEach((searchKey: string) => {
        filteredData.push(...data.filter((element: any) => {
          return element[option].indexOf(searchKey) > -1;
        }));
      });
      filteredData.forEach((ele:any, index: any) => {
        ele['_key'] = index + 1;
      });
    }
    this.tableData = [...filteredData];
    this.$store.commit('stopLoading');
  }

  public exportData() {
    ExportcsvService.startExport(this.mapDataForExport(this.returnData), 'PreferenceFileDownloadReport.csv');
  }

  public printDetails() {
    const url = `${window.location.origin}/workspace/m/print-preference-file-download-report`;
    window.open(url, '_blank');
  }

  public mapDataForExport(data: any[]) {
    let tempArr: any = [];
    const itemHeader: string[] = [];
    this.getColumnsConfig.map((entry: TableColumnConfig) => {
      if (entry.key !== 'index' && typeof entry.title === 'string') {
        itemHeader.push(entry.title);
      }
    });
    const tempJson: any = [{}, itemHeader];
    data.map((dataItem:any) => {
      const obj = {};
      this.getColumnsConfig.forEach((item) => {
        if (item.dataKey) {
          if (item.key === 'LastDownloadTime') {
            const date = dataItem[item.dataKey];
            const formattedDate = date;
            // @ts-ignore
            obj[item.title] = formattedDate || '';
          } else {
            // @ts-ignore
            obj[item.title] = `${dataItem[item.dataKey]}` || '';
          }
        }
      });
      tempJson.push(obj);
    });
    tempArr = tempArr.concat(tempJson);
    return tempArr;
  }

  public serialNumberClick(serialNumber: string) {
    this.$router.push({ path: `/m/feature/products?serialNumber=${serialNumber}` })
    .catch((routeError: Error) => {
      console.error(routeError);
    });
  }
}
